<template>
    <span :class="[namespace(), skinStyle]">
        <svg
            v-if="value >= 1 && value <= 9"
            :class="mdsNS('icon button__icon button_msbox')"
            role="img"
            :aria-label="styleBoxes[value].alt"
            :alt="styleBoxes[value].alt"
        >
            <use :xlink:href="`#style-box-${styleBoxes[value].style}`">
                <title>Style Box</title>
            </use>
        </svg>
        <span v-else>—</span>
    </span>
</template>

<script>
import utils from '../../utils';
import mixins from '../mixins';
export default {
    name: 'markets-ui-style-box',
    mixins: [mixins],
    props: {
        value: {
            type: [Number, String],
            default: 0
        },
        altLabels: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    created() {
        this.namespace = utils.namespace('ui-style-box', false);
        const valueAlt = utils.extend(
            {
                largeValue: 'Large Value',
                largeCore: 'Large Core',
                largeGrowth: 'Large Growth',
                middleValue: 'Middle Value',
                middleCore: 'Middle Core',
                middleGrowth: 'Middle Growth',
                smallValue: 'Small Value',
                smallCore: 'Small Core',
                smallGrowth: 'Small Growth'
            },
            this.altLabels
        );
        this.styleBoxes = [
            {},
            { style: 'top-left', alt: valueAlt.largeValue },
            { style: 'top-mid', alt: valueAlt.largeCore },
            { style: 'top-right', alt: valueAlt.largeGrowth },
            { style: 'middle-left', alt: valueAlt.middleValue },
            { style: 'middle-mid', alt: valueAlt.middleCore },
            { style: 'middle-right', alt: valueAlt.middleGrowth },
            { style: 'bottom-left', alt: valueAlt.smallValue },
            { style: 'bottom-mid', alt: valueAlt.smallCore },
            { style: 'bottom-right', alt: valueAlt.smallGrowth }
        ];
    },
    computed: {
        skinStyle() {
            return this.namespace(`__${utils.getSkinSuffix(this.skin)}`);
        }
    }
};
</script>

<style lang="scss">
@import '../../mds/constants';
$namespace: 'markets-ui-style-box';
.#{$namespace} {
    &__dark-gray {
        svg {
            fill: $mds-text-color-primary-on-dark;
        }
    }
}
</style>
